import { LanguageSelect } from "@/components/common";
import { useCurrentPlatform } from "@/contexts";
import { useT } from "@/i18n";
import { IconBurger, IconButton } from "@/ui";

import { GlobalSearch, MobileGlobalSearch } from "../GlobalSearch";

import { DashboardHeaderCreateButton } from "./DashboardHeaderCreateButton";
import { OrganizationSelect } from "./OrganizationSelect";
import { UserProfileDropdown } from "./UserProfileDropdown";

type DashboardHeaderProps = {
  onMenuClick?: () => void;
};

export const DashboardHeader = ({ onMenuClick }: DashboardHeaderProps) => {
  const t = useT();
  const currentPlatform = useCurrentPlatform();

  return (
    <div className="bg-surface-1 sticky w-full overflow-hidden h-[60px] shrink-0 top-0 z-40 flex items-center px-4 md:px-5 py-2.5 border-b-small border-surface-2 justify-between gap-6">
      <div className="hidden items-center justify-between w-full md:flex gap-5">
        <OrganizationSelect />
        <GlobalSearch className="max-w-[560px] w-full" />
        <div className="flex gap-5 lg:gap-10 items-center">
          <DashboardHeaderCreateButton />

          <div className="flex items-center gap-10">
            <LanguageSelect isIconOnly allowedLanguages={currentPlatform.languages} />
            <UserProfileDropdown />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between w-full md:hidden gap-5">
        <OrganizationSelect />

        <GlobalSearch className="max-w-[560px] hidden md:flex" />
        <div className="flex gap-4 items-center shrink-0">
          <MobileGlobalSearch />
          {/* Create button hidden for now — language select shown instead */}
          {/* <DashboardHeaderCreateButton /> */}
          <LanguageSelect isIconOnly allowedLanguages={currentPlatform.languages} />
          <UserProfileDropdown />

          {onMenuClick && (
            <IconButton
              hideTooltip
              onPress={onMenuClick}
              label={t("general.actions.open")}
              className="md:hidden"
              icon={IconBurger}
            />
          )}
        </div>
      </div>
    </div>
  );
};
